export default __webpack_public_path__ + "static/media/colors.ac41c5d3.jpg";